export function scrollTo() {

  $(".scroll-to").on("click", function (event) {
    event.preventDefault();
    var id  = $(this).attr('href'),
    top = $(id).offset().top - $('.header').outerHeight() - 20;
    $('body,html').stop().animate({scrollTop: top}, 600);
  });

}


// WEBPACK FOOTER //
// ./assets/js/modules/scroll-to.js